/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-25 09:16:27
 *
 *******************************************************/
// @flow

import { getJSON } from 'redux-api-middleware';
import { I18n } from '@shopify/react-i18n';
import { processRes } from 'src/helpers/actions-helper';

import apiService from 'src/services/api-service';
import {
  GET_LOCALES_REQUEST,
  GET_LOCALES_SUCCESS,
  GET_LOCALES_FAILURE,
  GET_DEFAULT_TRANSLATIONS_BY_LOCALE_REQUEST,
  GET_DEFAULT_TRANSLATIONS_BY_LOCALE_SUCCESS,
  GET_DEFAULT_TRANSLATIONS_BY_LOCALE_FAILURE
} from 'stores/flow-type/translation.type';

/**
 * call to get all supported locales of the store
 * @return {object} The RSAA object for API middleware
 */
export const getLocales = (i18n: I18n) => {
  return apiService.sendRequest('admin-v3.locales.get-locales', {}, [
    GET_LOCALES_REQUEST,
    {
      type: GET_LOCALES_SUCCESS,
      payload: async (action, state, res) => {
        const data = await getJSON(res);

        return { data };
      }
    },
    {
      type: GET_LOCALES_FAILURE,
      payload: async (action, state, res) =>
        await processRes(
          res,
          'error',
          i18n.translate('AdminHTML.Translation.Actions.getLocales'),
          i18n
        )
    }
  ]);
};

/**
 * Get default label translations by locale
 *
 * @param  {string} locale
 *
 * @return {array}        default label translations
 */
export const getDefaultLabelTranslations = (locale: string, i18n: I18n) => {
  return apiService.sendRequest(
    'admin-v3.label-translations.get-default-translations',
    { queries: { locale } },
    [
      GET_DEFAULT_TRANSLATIONS_BY_LOCALE_REQUEST,
      {
        type: GET_DEFAULT_TRANSLATIONS_BY_LOCALE_SUCCESS,
        payload: async (action, state, res) => {
          const data = await getJSON(res);

          return { data, locale };
        }
      },
      {
        type: GET_DEFAULT_TRANSLATIONS_BY_LOCALE_FAILURE,
        payload: async (action, state, res) =>
          await processRes(
            res,
            'error',
            i18n.translate('AdminHTML.Translation.Actions.getDefaultLabelTranslations'),
            i18n
          )
      }
    ]
  );
};
